import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  dashboardsSelector,
  afterInitializationSelector,
} from '@store/tempDashboard/selectors';
import * as tempDashboardActions from '@store/tempDashboard/actions';
import { TableWrapper } from './styled';
import Table from '@src/components/common/Table';
import columns from './columns';


function TempDashboards() {
  const dispatch = useDispatch();
  const localStorageInit = useSelector(afterInitializationSelector);
  const dashboards = useSelector(dashboardsSelector);

  // load temp dashboard data from LS
  useEffect(() => {
    if (!localStorageInit) {
      dispatch(tempDashboardActions.init());
    }
  }, [dispatch, localStorageInit]);


  useEffect(() => {
    if(localStorageInit) {
      // dispatch(tempDashboardActions.cleanTempDashboards());
    }

  }, [localStorageInit]);

  const data = Object.values(dashboards);


  return (
    <div>
      <div>Temp Dashboards</div>
      <div>
      <TableWrapper style={{ height: 800 }}>
        <Table
          data={data}
          columns={columns}
          headerHeight={50}
          rowHeight={40}
          fixed
          // maxHeight={280}
          // rowEventHandlers={{ onClick: onRowClick }}
          // rowClassName={getRowClass}
          // rowRenderer={Row}
          // components={{ TableHeaderCell }}
          // headerProps={{ unit, pctShareTotals, expand }}
          //rowKey="filter"
        />
      </TableWrapper>
    </div>
    </div>
  );
}

export default TempDashboards;
